import React from 'react';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { useApi } from '../hooks/useApi';
import useThemes from '../hooks/useThemes';

export const AboutUs = () => {
  const history = useHistory();
  const { backgroundWhite, backgroundOctavo, colorSecundario } = useThemes();
  const { modeloAtencion, getModeloAtencion } = useApi();
  const { quienesSomosBtn, getQuinesSomosBtn } = useApi();

  useEffect(() => {
    getModeloAtencion();
    getQuinesSomosBtn();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Container
      background={backgroundWhite}
      color={colorSecundario}
      backgroundcirculo={backgroundOctavo}
      isModeloActive={modeloAtencion?.data?.activo}
    >
      <div className='sub-container'>
        {quienesSomosBtn?.data?.activo && (
          <div className='item' onClick={() => history.push('/quienes')}>
            <div className='img-container'>
              <img src={quienesSomosBtn?.data?.imagen
                    ? quienesSomosBtn?.data?.imagen
                    : 'img/Quienes-somos/doctor_1.png'
                } alt='¿Quines Somos?' />
            </div>
            <div className='text-container'>
              <p>
                ¿Quienes <br /> somos?
              </p>
            </div>
          </div>
        )}

        {modeloAtencion?.data?.activo && (
          <div
            className='item'
            onClick={() => history.push('/modelo-atencion')}
          >
            <div className='img-container'>
              <img
                src={
                  modeloAtencion?.data?.imagen
                    ? modeloAtencion?.data?.imagen
                    : 'img/Modelo-atencion/Calendario22.png'
                }
                alt='Doctor'
              />
            </div>
            <div className='text-container'>
              <p>
                Modelo de <br /> atención
              </p>
            </div>
          </div>
        )}
      </div>
    </Container>
  );
};

// ##### Estilos #####
const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 12rem;

  .sub-container {
    display: grid;
    gap: 2rem;
    grid-template-columns:${(props) =>
      props.isModeloActive ? '1fr 1fr;' : '1fr;'}
    width: ${(props) => (props.isModeloActive ? '90%;' : '40%;')}

    .item {
      display: flex;
      align-items: center;
      border-radius: 10vw;
      cursor: pointer;
      background-color: ${(props) => props.background};
      box-shadow: 0 0 6px #808080;
      transition: all 0.2s;

      .img-container {
        width: 15vw;
        border-radius: 10vw;
        overflow: hidden;
        background-color: ${(props) => props.backgroundcirculo};

        img {
          width: 100%;
          height: auto;
          transition: all 0.2s;
        }
      }

      .text-container {
        margin-left: 2rem;

        p {
          font-size: 5rem;
          font-weight: 700;
          line-height: 5rem;
          color: ${(props) => props.color};
        }
      }

      &:hover {
        background-color: ${(props) => props.color};

        p {
          color: ${(props) => props.background};
        }

        img {
          transform: translateY(15%) scale(150%);
        }
      }
    }
  }

  @media (max-width: 1023px) {
    padding-top: 28rem;

    .sub-container {
      grid-template-columns: 1fr;
      width: ${(props) => (props.isModeloActive ? '90%;' : '75%;')}

      .item {
        border-radius: 20vw;

        .img-container {
          width: 40vw;
          border-radius: 20vw;
        }

        .text-container {
          p {
            font-size: 5rem;
            line-height: 5rem;
          }
        }
      }
    }
  }

  @media (max-width: 800px) {
    padding-top: 30rem;

    .sub-container {
      grid-template-columns: 1fr;

      .item {
        border-radius: 20vw;

        .img-container {
          width: 40vw;
          border-radius: 20vw;
        }

        .text-container {
          p {
            font-size: 3rem;
            line-height: 3rem;
          }
        }
      }
    }
  }

  @media (max-width: 520px) {
    padding-top: 15rem;

    .sub-container {
      grid-template-columns: 1fr;

      .item {
        border-radius: 20vw;

        .img-container {
          width: 40vw;
          border-radius: 20vw;
        }

        .text-container {
          p {
            font-size: 3rem;
            line-height: 3rem;
          }
        }
      }
    }
  }
`;
